import React from 'react';
import { useTranslation } from 'react-i18next';
import { LabelInput } from '@/components/ui/inputs/LabelInput';
import type { AbsenceItem } from '@/api/domains/absence/absence.types';
import { SidePanelFormLayout } from '@/components/layout';


interface AbsenceDetailFormProps {
  data: AbsenceItem;
}

const AbsenceDetailForm: React.FC<AbsenceDetailFormProps> = ({ data }) => {
  const { t: translate } = useTranslation('absence');

  return (
    <SidePanelFormLayout>
      <SidePanelFormLayout.Fields>
        <LabelInput
          label={translate('form.id')}
          value={data.id}
          disabled
          fullWidth
        />

        <LabelInput
          label={translate('form.tipo')}
          value={data.tipo}
          disabled
          fullWidth
        />

        <LabelInput
          label={translate('form.descripcion')}
          value={data.descripcion}
          disabled
          fullWidth
        />

        <LabelInput
          label={translate('form.fechaDesde')}
          value={data.fechaDesde}
          disabled
          fullWidth
        />

        <LabelInput
          label={translate('form.fechaHasta')}
          value={data.fechaHasta}
          disabled
          fullWidth
        />

        <LabelInput
          label={translate('form.estado')}
          value={data.estado}
          disabled
          fullWidth
        />

        <LabelInput
          label={translate('form.fechaCreacion')}
          value={data.fechaCreacion}
          disabled
          fullWidth
        />

        <LabelInput
          label={translate('form.creadoPor')}
          value={data.creadoPor}
          disabled
          fullWidth
        />
      </SidePanelFormLayout.Fields>
    </SidePanelFormLayout>
  );
};

export default AbsenceDetailForm;
